import http from '@core/fetch'

export default {
  //三级地址
  getPCCApi: body => http('/p/wedding/shop/APIShopAddress/AllAddress', { body })
}
